module.exports = __webpack_public_path__ + "df32b35a5140cd9348f6ec9a57034055.svg";